/**
 * 全屏弹窗浏览器后退拦截 mixin
 * 
 * 功能：当全屏弹窗打开后，拦截浏览器后退功能，使用关闭弹窗代替后退
 * 
 * 使用方式：
 * 1. 引入 mixin: import dialogBackInterceptor from '@/plugins/dialogBackInterceptor'
 * 2. 在组件中使用 mixins: [dialogBackInterceptor]
 * 3. 确保组件有 dialog 数据属性控制弹窗显隐
 * 
 * 注意事项：
 * - 组件需要有 data.dialog 属性来控制弹窗显隐
 * - mixin 会自动监听 dialog 变化并管理历史记录
 */
export default {
  data() {
    return {
      // 标记是否由后退按钮触发关闭
      isDialogClosingByBack: false,
      // 存储事件处理函数引用，用于清理
      _popstateHandler: null,
    };
  },

  watch: {
    dialog: {
      handler(newVal) {
        if (newVal) {
          // 弹窗打开时设置历史监听
          this.setupHistoryListener();
        } else {
          // 弹窗关闭时清理历史监听
          this.cleanupHistoryListener();
        }
      },
    },
  },

  beforeDestroy() {
    // 组件销毁前清理事件监听
    this.cleanupHistoryListener();
  },

  methods: {
    /**
     * 添加历史记录并监听 popstate 事件
     * 当用户点击浏览器后退按钮时，会触发关闭弹窗而不是页面导航
     */
    setupHistoryListener() {
      // 避免重复添加
      if (this._popstateHandler) return;

      // 添加一个历史记录条目
      window.history.pushState({ dialog: true }, '', window.location.href);

      // 监听后退事件
      this._popstateHandler = () => {
        // 标记是由后退按钮触发的关闭
        this.isDialogClosingByBack = true;
        // 关闭弹窗
        this.dialog = false;
      };
      window.addEventListener('popstate', this._popstateHandler);
    },

    /**
     * 清理历史记录监听
     * 移除事件监听器并重置标志
     */
    cleanupHistoryListener() {
      if (this._popstateHandler) {
        window.removeEventListener('popstate', this._popstateHandler);
        this._popstateHandler = null;
      }
      // 重置标志
      if (this.isDialogClosingByBack) {
        this.isDialogClosingByBack = false;
      }
    },
  },
};
